import { useState, useEffect } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';

const SIZE = 56;
const HALF = SIZE / 2;
const FAST = { stiffness: 1400, damping: 60, mass: 0.15 };
const TRAIL = { stiffness: 900, damping: 45, mass: 0.25 };

const CustomCursor = () => {
  const [isHovering, setIsHovering] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const cx = useSpring(x, FAST);
  const cy = useSpring(y, FAST);
  const dx = useSpring(x, TRAIL);
  const dy = useSpring(y, TRAIL);

  useEffect(() => {
    const move = (e) => { x.set(e.clientX); y.set(e.clientY); };
    const over = (e) => setIsHovering(!!e.target.closest('a, button, [role="button"], input, textarea, select, [data-cursor-hover]'));
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseover', over);
    return () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseover', over);
    };
  }, [x, y]);

  return (
    <>
      <motion.div className="fixed top-0 left-0 pointer-events-none z-[10003] mix-blend-difference" style={{ x: cx, y: cy, translateX: -HALF, translateY: -HALF }} data-testid="custom-cursor">
        <motion.svg width={SIZE} height={SIZE} viewBox="0 0 40 40" fill="none" animate={{ scale: isHovering ? 1.4 : 1 }} transition={{ duration: 0.12 }}>
          <line x1="20" y1="0" x2="20" y2="15" stroke="white" strokeWidth="1.8" />
          <line x1="20" y1="25" x2="20" y2="40" stroke="white" strokeWidth="1.8" />
          <line x1="0" y1="20" x2="15" y2="20" stroke="white" strokeWidth="1.8" />
          <line x1="25" y1="20" x2="40" y2="20" stroke="white" strokeWidth="1.8" />
          <circle cx="20" cy="20" r="3.5" stroke="white" strokeWidth="1.8" fill="none" />
        </motion.svg>
      </motion.div>
      <motion.div className="fixed top-0 left-0 pointer-events-none z-[10002] w-3 h-3 bg-primary rounded-full" style={{ x: dx, y: dy, translateX: -6, translateY: -6 }} />
    </>
  );
};

export default CustomCursor;
